import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import icon1 from '../../assets/img/icons/flag.png';
import icon3 from '../../assets/img/icons/eye.png';
import icon4 from '../../assets/img/icons/value.png';

const facilities = [
    { icon: icon3, title: 'Vision', text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. "},
    { icon: icon1, title: 'Mission', text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."},
    { icon: icon4, title: 'Values', text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. "}
];

class Facilities extends Component {
    render() {
        return (
            <div className="row">
                {facilities.map((item, i) => (
                    <div className="col-xl-4 col-lg-4 col-md-6" key={i}>
                        <Link to="/" className="sigma_service style-2">
                            <div className="sigma_service-thumb">
                                <img src={item.icon} alt="" style={{width: "40%"}}/>
                            </div>
                            <div className="sigma_service-body">
                                <h5>{item.title}</h5>
                                <p>{item.text}</p>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
        );
    }
}

export default Facilities;